import styled from 'styled-components'

import { DocsGridTable } from '@/components/common/docs-grid-table'

const ConsoleWrapper = styled(DocsGridTable)`
  table {
    width: 100%;
    border-collapse: collapse;
  }

  table th:not(:first-child) {
    padding-left: 10px;
  }

  td,
  ul {
    background: ${({ theme }) => theme.palette.giphyDarkGrey};
    color: rgb(255, 255, 255);
    font-family: PTMono-Regular;
    font-size: 16px;
    border-radius: 2px;
    line-height: 33px;
    padding: 16px 0 16px 30px;
  }

  ul {
    list-style: none;
  }

  ul a {
    color: ${({ theme }) => theme.palette.giphyAqua};
    border-bottom: 1px ${({ theme }) => theme.palette.giphyAqua} solid;
  }
`

export default ConsoleWrapper
